import type { IRowNode, ValueGetterParams } from "ag-grid-community";
import type {
  TCell,
  TData,
  nthNextCalsByYearAndMonth,
  nthNextHlvsByYearAndMonth,
  nthNextMonthsByYearAndMonth,
  nthNextQtrsByYearAndMonth,
  nthNextSeasonsByYearAndMonth,
} from "@package/grid-utils";

export function getNodePeriod(node: IRowNode<TData>): string {
  if (node.data?.rowType === "adhoc") {
    return node.data.id;
  }

  return node?.data?.period ?? "";
}

export const monthTimespreadValueGetter =
  (monthData: {
    nextMonths: ReturnType<typeof nthNextMonthsByYearAndMonth>;
    nextQtrs: ReturnType<typeof nthNextQtrsByYearAndMonth>;
    nextHlvs: ReturnType<typeof nthNextHlvsByYearAndMonth>;
    nextCal: ReturnType<typeof nthNextCalsByYearAndMonth>;
    nextSeasons: ReturnType<typeof nthNextSeasonsByYearAndMonth>;
  }) =>
  (params: ValueGetterParams<TData, TCell>) => {
    const data = params.data;
    if (data === undefined) {
      return "";
    }
    const rowType = data.rowType;
    const period = data.period;
    const code = data.code || "";

    if (!period) return "";

    if (rowType === "adhoc") {
      if (period === " " && code === " ") {
        return " ";
      }
      return code ? `${period}/${code}` : period;
    }
    switch (rowType) {
      case "mth":
        return `${period}/${parseNextPeriod(monthData.nextMonths, period) || ""}`;
      case "qtr":
        return `${period}/${parseNextPeriod(monthData.nextQtrs, period) || ""}`;
      case "hlv":
        return `${period}/${parseNextPeriod(monthData.nextHlvs, period) || ""}`;
      case "cal":
        return `${period}/${parseNextPeriod(monthData.nextCal, period) || ""}`;
      case "season":
        return `${period}/${parseNextPeriod(monthData.nextSeasons, period) || ""}`;
      default:
        return period;
    }
  };

const parseNextPeriod = (nextPeriod: Array<readonly [number, string]>, period: string): string | undefined => {
  const foundIndex = nextPeriod.findIndex((item) => period === item[1]);
  if (foundIndex !== -1 && foundIndex + 1 < nextPeriod.length) {
    return nextPeriod[foundIndex + 1][1];
  }
};
